import React from 'react';
import { Heading4, Text } from '@origin-digital/style-guide';
import { Stack } from '@origin-digital/ods-core';
import Countdown from 'react-countdown';

interface TimerProps {
  onTimerComplete: () => void;
  showTimer: boolean;
  countdown: number;
}

const OneTimeCodeTimer: React.FC<TimerProps> = ({ showTimer, onTimerComplete, countdown }) => {
  const countdownRenderer = ({ minutes, seconds }) => {
    const minutesDisplay = minutes >= 10 ? minutes : `0${minutes}`;
    const secondsDisplay = seconds >= 10 ? seconds : `0${seconds}`;
    return (
      <Stack alignX={'center'} space={'medium'}>
        <Text data-id={'countdown-text'}>You can request a new code in:</Text>
        <Heading4 data-id={'timer'} text={minutesDisplay + ':' + secondsDisplay} />
      </Stack>
    );
  };

  return showTimer ? (
    <Countdown
      data-id={'countdown'}
      date={countdown}
      renderer={countdownRenderer}
      onComplete={onTimerComplete}
    />
  ) : null;
};

export { OneTimeCodeTimer };
